export const MAX_PROGRESS_LENGTH = 12;

export const MIN_PROGRESS_LENGTH = 1;
